<template>
<div class="invoice-lisi">
  <el-dialog
    title="申请开票"
    width="800px"
    custom-class="apply-invoice-list"
    :visible.sync="dialogVis.applyInvoiceList"
    :append-to-body="true"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @closed="closeDialog">

    <el-dialog
      title="修改发票抬头"
      width="400px"
      custom-class="edit-invoice-title"
      :append-to-body="true"
      :visible.sync="dialogVis.editInvoiceTitle"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <div class="content">
        <div class="input-item">
          <span class="red">*</span>
          <span class="text">企业名称：</span>
          <my-input
            @input="inputLimitNormal(editInvoiceInfo, 'companyName')"
            v-model="editInvoiceInfo.companyName"
            class="base-input"
            placeholder="请输入企业名称">
          </my-input>
        </div>
        <div class="input-item">
          <span class="red">*</span>
          <span class="text">税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</span>
          <my-input
            @input="inputLimitNumber(editInvoiceInfo, 'invoiceNum')"
            @focus="invoiceNumErr = ''"
            @blur="invoiceNumBlur"
            :errMessage="invoiceNumErr"
            v-model="editInvoiceInfo.invoiceNum"
            class="base-input"
            placeholder="请输入纳税人识别号">
          </my-input>
        </div>
      </div>
      <div class="use-btn">
        <button class="my-button" @click="confirmInvoiceTitle" :disabled="!confirmButton">确认</button>
        <button class="my-button-cancel" @click="dialogVis.editInvoiceTitle = false">取消</button>
      </div>
    </el-dialog>

    <div class="content">
      <el-table
        ref="multipleTable"
        :data="dataList"
        @select="handleSelection"
        @selection-change="handleSelectionChange"
        v-loading="tableLoading"
        highlight-current-row
        height="310px"
        style="width:100%"
        v-scrollListen="{el: '.el-table__body-wrapper', fn: scrollLoad}">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="购买服务/商品" min-width="100" prop="purchaseGoods"></el-table-column>
        <el-table-column label="规格/数量" min-width="80" align="right">
          <template slot-scope="scope">
            <span v-if="scope.row.size">{{scope.row.size}}/</span>
             <span v-if="checkIsComposeGoods(scope.row.fee_code)">{{`${scope.row.portion_number}${isStaff(scope.row.fee_code) ? '个' : '套'}${scope.row.count}年`}}</span>
             <span v-else-if="isNewLsStaffSeat(scope.row.fee_code)">{{`${scope.row.count}个`}}</span>
              <span v-else>{{scope.row.count}}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" width="70" align="right">
          <template slot-scope="scope">
            <p v-if="scope.row.validity">永久</p>
            <p v-else>一年</p>
          </template>
        </el-table-column>
        <el-table-column
          label="付款金额(元)"
          width="100"
          prop="payMoney"
          align="right"
          :formatter="changeMoney">
        </el-table-column>
        <el-table-column label="订单号" min-width="150" prop="recordCode"></el-table-column>
        <el-table-column label="支付完成时间" min-width="90">
          <template slot-scope="scope">
            <p>{{scope.row.payTime.split(' ')[0]}}</p>
            <p>{{scope.row.payTime.split(' ')[1]}}</p>
          </template>
        </el-table-column>
        <p slot="append" style="text-align:center;padding:10px;" v-if="tableLoading">{{MIXIN_TableLodingText}}</p>
        <p slot="append" style="text-align:center;padding:10px;color:#999;" v-if="!isTableDataHasMore">没有更多了</p>
      </el-table>

      <div class="invoice-title-edit">
        <span class="invoice-title">发票抬头&nbsp;&nbsp;&nbsp;</span>
        <span class="invoice-name text-popper" v-textPopper>{{invoiceInfo.companyName}}</span>
        <span class="invoice-number"> （税号：{{invoiceInfo.invoiceNum}}）</span>
        <span class="edit-invoice" @click="editInvoice">编辑</span>
      </div>

    </div>

    <div class="content-footer">
      <span class="left">
        <el-checkbox :indeterminate="isIndeterminate" v-model="selectAll" @change="handleCheckAllChange" class="all"></el-checkbox>
        <span class="line-block select-all">全选</span>
        <span class="line-block invoice-money-title">开票金额：</span>
        <span class="line-block red sign">￥</span>
        <span class="line-block red invoice-money-con">{{invoiceTotalMoney}}</span>
      </span>
      <span class="right">
        <span class="line-block tips">开票须知</span>
        <el-tooltip placement="top-end">
          <div slot="content" class="content" style="width:389px;font-size:12px;line-height:18px;">
            说明：<br/>
            1.开票时间：无特殊或不可抗力情况下，我司将在3个工作日内为您开票，发票开出后可在【开票记录】中下载；<br/>
            2.开票类型：我司默认开票类型为增值税电子普通发票。如有特殊开票要求，可联系森果云客服:400-027-0135 沟通处理；<br/>
            3.开票税率：我司开出的发票金额均为含税价格，税率为3%；<br/>
            4.特殊说明：因我司每月开票数量有限，若当月开票量太大，发票限额用尽，将延迟为您开票，如急需开具发票，可联系森果云客服:400-027-0135，加急处理。
          </div>
          <svg class="icon line-block" aria-hidden="true">
            <use xlink:href="#iconyiwen1"></use>
          </svg>
        </el-tooltip>
        <div class="my-button line-block" @click="applyInvoice" :disabled="!applyButton">申请开票</div>
      </span>
    </div>
  </el-dialog>
  
  <el-dialog
    title="信息确认"
    width="450px"
    custom-class="confirm"
    :visible.sync="dialogVis.confirmInvoice"
    :append-to-body="true"
    :close-on-click-modal="false"
    :destroy-on-close="true">
    <div v-show="!confirmed">
      <div class="content">
        <div class="green-title">
          <span class="green-line"></span>
          <span class="con">发票抬头</span>
        </div>
        <div class="invoice-title">
          <div class="con">企业名称：{{invoiceInfo.companyName}}</div>
          <div class="con">税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：{{invoiceInfo.invoiceNum}}</div>
        </div>
        <div class="green-title">
          <span class="green-line"></span>
          <span class="con">开票订单</span>
        </div>
        <div class="invoice-detial">
          <el-table :data="invoiceDetialList" max-height="183px" style="width: 100%" highlight-current-row>
            <el-table-column prop="purchaseGoods" label="购买服务/商品" width="196"></el-table-column>
            <el-table-column label="规格/数量" width="100" align="right">
              <template slot-scope="scope">
                <span v-if="scope.row.size">{{scope.row.size}}/</span>
                <span v-if="checkIsComposeGoods(scope.row.fee_code)">{{`${scope.row.portion_number}${isStaff(scope.row.fee_code) ? "个" : '套'}${scope.row.count}年`}}</span>
                <span v-else-if="isNewLsStaffSeat(scope.row.fee_code)">{{`${scope.row.count}个`}}</span>
                <span v-else>{{scope.row.count}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payMoney" label="付款金额(元)" width="130" align="right" :formatter="changeMoney">
            </el-table-column>
          </el-table>
          <div class="total">
            <span class="con">开票金额</span>
            <span>
              <span class="red sign">￥</span>
              <span class="red word">{{invoiceConfirmMoney}}</span>
              <span class="gray">(含税)</span>
            </span>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="use-btn">
          <button class="my-button" @click="confirmedInvoice">确认</button>
          <button class="my-button-cancel" @click="dialogVis.confirmInvoice = false">取消</button>
        </div>
      </div>
    </div>
    <div v-show="confirmed" class="confirmed">
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#iconzucechenggong"></use>
      </svg>
      <div class="tip1">申请提交成功，请耐心等待处理</div>
      <div class="tip2">发票开出后，可在【开票记录】中下载发票</div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { inputLimit } from '@/assets/js/util'
import myInput from './my-input'
import { 
  checkFeeInfo, 
  PF_SELF_SERVICE_PART,
  PF_SELF_SERVICE_ANNUAL_FEE,
  PF_STAFF_NUM,
  NEW_LS_STAFF_SEAT
 } from '../const'

export default {
  data() {
    return {
      dataList: [], // 申请开票的列表
      dialogVis: {
        applyInvoiceList: false, // 显示申请开票
        editInvoiceTitle: false, // 显示修改发票抬头
        confirmInvoice: false, // 显示信息确认
      }, // dialog的显示与隐藏
      invoiceInfo: {
        companyName: "", // 发票抬头信息
        invoiceNum: "", // 发票纳税人识别码
      }, // 发票抬头信息
      editInvoiceInfo: {}, // 修改发票抬头
      multipleSelection: [], // 多选发票申请的内容
      invoiceDetialList: [], // 信息确认时，开票订单中的详情
      confirmed: false, // 显示确认信息时，控制确认前和确认后
      isIndeterminate: false, // 设置checkbox中 indeterminate 状态，只负责样式控制
      selectAll: false, // 设置CheckBox中v-model的状态，CheckBox的状态有三种
      invoiceNumErr: '', // 输入错误的税号时的提示
    }
  },

  computed: {
    /**
     * 计算开票金额的总价
     */
    invoiceTotalMoney: function() {
      return this.formatterMoney(this.multipleSelection.reduce((total, value) => total += value.payMoney, 0).toFixed(2))
    },
    invoiceConfirmMoney: function() {
      return this.formatterMoney(this.invoiceDetialList.reduce((total, value) => total += value.payMoney, 0).toFixed(2))
    },

    /**
     * 是否可以点击申请开票按钮
     */
    applyButton: function() {
      return this.multipleSelection.length > 0
    },

    /**
     * 是否可以点击修改发票抬头的确认按钮，
     */
    confirmButton: function() {
      let reg = /^[0-9a-zA-Z]{15,20}$/
      let invoiceRight = reg.test(this.editInvoiceInfo.invoiceNum)
      return this.editInvoiceInfo.companyName && this.editInvoiceInfo.invoiceNum && invoiceRight
    },
  },

  methods: {
    inputLimitNormal: inputLimit(/^\S{0,50}$/),
    inputLimitNumber: inputLimit(/^[0-9a-zA-Z]{0,20}$/),

    /**
     * 打开申请发票界面
     */
    open(companyName, invoiceNum) {
      this.dialogVis.applyInvoiceList = true
      this.invoiceInfo.companyName =  companyName
      this.invoiceInfo.invoiceNum = invoiceNum
      this.init()
    },

    /**
     * 页面初始化
     */
    init() {
      if(this.$route.query.shop_id && this.$route.query.shop_type && this.$route.query.shop_name && this.$route.query.shop_super_admin_passport_id){
        this.getTableList()
      }
    },

    checkIsComposeGoods(code) {
      return checkFeeInfo(code, [PF_SELF_SERVICE_PART, PF_SELF_SERVICE_ANNUAL_FEE, PF_STAFF_NUM])
    },
    isNewLsStaffSeat(code) {
        return checkFeeInfo(code, [NEW_LS_STAFF_SEAT])
    },
    isStaff(code) {
        return checkFeeInfo(code, [PF_STAFF_NUM])
    },

    /**
     * 获取申请发票的列表
     * @param {number} page 页数
     */
    getTableList(page = 0) {
      this.tableLoading = true
      return this.$fetch.jsonRPC({
        url: "/fee",
        method: "get_fee_list",
        params: {
          shop_id: this.$route.query.shop_id,
          shop_type: this.$route.query.shop_type,
          page: page,
          pagesize: 10,
          has_invoice: 0,
        },
      }).then(res => {
        let hasMore = res.has_more;
        let data = [];
        if(res.fee_record_list.length === 0) {
          return { data: null, has_more: false};
        }
        data = res.fee_record_list.map(item => {
          const paymentDetail = item.payment_detail || {}
          const claimItem = paymentDetail.claim_item || {}
          return {
            id: item.id,
            purchaseGoods: claimItem.payment_target_detail || item.fee_info.goods_item,
            size: claimItem.quantity_text || paymentDetail.period_text || item.fee_info.size,
            count: item.count,
            portion_number: item.portion_number,
            fee_code: item.fee_info.fee_code,
            validity: item.fee_info.expired_date,
            payMoney: item.pay_money,
            recordCode: item.record_code,
            payTime: item.pay_time,
          }
        })
        if(page === 0){
          this.dataList = data
          this.initScrollTable(hasMore)
        } else {
          this.dataList = this.dataList.concat(data)
        }
        return {data, has_more: hasMore}
      }).catch(e => {
        this.openMessage(0, e.error_text || "获取店铺付费列表信息失败")
      }).finally(() => {
        this.tableLoading = false
        if(this.multipleSelection.length > 0) {
          this.multipleSelection.forEach(item => [
            this.$refs.multipleTable.toggleRowSelection(item)
          ])
        }
      })
    },

    /**
     * 编辑发票抬头信息
     */
    editInvoice() {
      this.editInvoiceInfo = JSON.parse(JSON.stringify(this.invoiceInfo))
      this.dialogVis.editInvoiceTitle = true
    },

    /**
     * 修改发票抬头的确认按钮
     */
    confirmInvoiceTitle() {
      this.invoiceInfo.companyName = this.editInvoiceInfo.companyName
      this.invoiceInfo.invoiceNum = this.editInvoiceInfo.invoiceNum
      this.dialogVis.editInvoiceTitle = false
    },

    /**
     * 调用格式化钱的输出
     * @param {Object} row 当前d的行对象
     * @return {string}
     */
    changeMoney(row) {
      return this.formatterMoney(row.payMoney)
    },

    /**
     * 格式化钱的输出
     * @param {number} row
     * @return {string} 已**.**的格式返回价格的字符串
     */
    formatterMoney(value) {
      if (String(value).includes(".")) {
        if (String(value).split(".")[1].length === 2) {
          return `${value}`;
        } else if (String(value).split(".")[1].length === 1) {
          return `${value}0`;
        } else {
          return value.toFixed(2)
        }
      } else {
        return `${value}.00`;
      }
    },

    /**
     * 选择申请开票时选择需要开票的项目
     * @param {Array} val 已选中的项目
     */
    handleSelectionChange(val) {
      // 通过全选按钮修改选中项时才修改multipleSelection中的数据，下拉加载数据时不修改选中项数据
      if(this.selected) {
        this.multipleSelection = val
      }
      let selectCount = val.length
      this.selectAll = selectCount === this.dataList.length
      this.isIndeterminate = selectCount > 0 && selectCount < this.dataList.length
      this.selected = false
    },

    /**
     * 点击开票选项时
     * @param {Array} val 已选中的项目
     */
    handleSelection(val) {
      this.multipleSelection = val
      let selectCount = val.length
      this.selectAll = selectCount === this.dataList.length
      this.isIndeterminate = selectCount > 0 && selectCount < this.dataList.length
    },

    /**
     * 根据表中选中的选项，改变el-checkbox的值
     */
    handleCheckAllChange() {
      // 切换所有行的选中状态
      this.$refs.multipleTable.toggleAllSelection()
      this.isIndeterminate = false
      this.selected = true  // 通过全选按钮修改选中项
    },

    /**
     * 申请开票时的确认
     */
    applyInvoice() {
      if(this.multipleSelection.length <= 0) return
      this.invoiceDetialList = this.multipleSelection.map(current => {
        return {
          id: current.id,
          fee_code: current.fee_code,
          purchaseGoods: current.purchaseGoods,
          payMoney: current.payMoney,
          portion_number: current.portion_number,
          count: current.count,
          size: current.size,
        }
      })
      this.dialogVis.applyInvoiceList = false
      this.dialogVis.confirmInvoice = true
    },

    /**
     * 信息确认，并提交需要开的发票
     */
    confirmedInvoice() {
      if(this.lock) return
      this.lock = true
      this.$fetch.post({
        url: '/invoiceticket?method=add_invoice_ticket',
        params: {
          company_name: this.invoiceInfo.companyName,
          company_uscc: this.invoiceInfo.invoiceNum,
          total_money: this.invoiceConfirmMoney,
          fee_record_ids: this.invoiceDetialList.map(item => parseInt(item.id)),
          shop_type: this.$route.query.shop_type,
          shop_id: this.$route.query.shop_id,
          shop_name: this.$route.query.shop_name,
        }
      }).then(() => {
        this.confirmed = true
        this.$emit('updateRecord', true)
        this.multipleSelection = []
        this.isIndeterminate = false
        this.selectAll = false
        setTimeout(() => {
          this.dialogVis.confirmInvoice = false
        }, 3000);
      }).catch(e => {
        this.openMessage(0, e.error_text || '提交发票信息失败，请稍后再试')
      }).finally(() => {
        this.lock = false
      })
    },

    /**
     * 修改发票时，税号填写错误时的提示
     */
    invoiceNumBlur() {
      let reg = /^[0-9a-zA-Z]{15,20}$/
      if(!reg.test(this.editInvoiceInfo.invoiceNum)) {
        this.invoiceNumErr = '请输入15至20位税号'
      }
    },

    /**
     * 关闭dialog时，恢复默认属性
     */
    closeDialog() {
      this.isIndeterminate = false
      this.selectAll = false
      this.confirmed = false
      this.multipleSelection = []
    }
  },

  components: {
    myInput,
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/ .el-table__header-wrapper {
  border: 1px solid #ebebeb;
  border-bottom: none;

  th {
    background: #FFF !important;

    .cell {
      font-size: 14px;
      color: #999;
      line-height: 20px;

      .el-checkbox {
        display: none;
      }
    }
  }
}

.apply-invoice-list {

  .content {
    padding: 0 12px 13px;

    .invoice-title-edit {
      margin-top: 12px;
      padding: 12px;
      height: 44px;
      border: 1px solid rgba(235,235,235,1);
      line-height: 20px;

      .invoice-title {
        color: #999;
      }

      .invoice-name {
        color: #333;
        max-width: 300px;
        width: auto;
        vertical-align: bottom;
      }

      .invoice-number {
        color: #333;
      }

      .edit-invoice{
        float: right;
        color: #1890FF;
        cursor: pointer;
      }
    }
  }

  .content-footer {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;
    padding: 10px 12px 10px 24px;
    border-top: 1px solid rgba(235,235,235,1);
    font-size: 14px;
    // line-height: 30px;

    .left {
      display: flex;
      align-items: center;
      .select-all {
        margin-left: 6px;
      }

      .invoice-money-title {
        margin-left: 20px;
      }

      .invoice-money-con {
        font-size: 22px;
        font-weight: 600;
        // vertical-align: baseline;
      }

      .red {
        color: #ff533a;
      }

      .sign {
        position: relative;
        top: -1px;
        align-self: flex-end;
        font-size: 14px;
      }
    }

    .right {
      display: flex;
      align-items: center;
      .icon {
        width: 18px;
        height: 18px;
        vertical-align: middle;
        margin-left: 6px;
        margin-right: 20px;
      }

      .my-button {
        text-align: center;
        line-height: 36px;
      }
    }

    .line-block {
      display: inline-block;
    }
  }
}

.edit-invoice-title {
  .content {
    padding: 20px 12px 0;

    .input-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .text {
        color: #333;
        font-size: 14px;
        line-height: 20px;
        width: 80px;
      }

      .red {
        position: relative;
        top: 5px;
        color: #E51C23;
        font-size: 26px;
      }

      .base-input {
        flex: 1;
      }
    }
  }

  .use-btn {
    margin-bottom: 12px;

    .my-button-cancel {
      margin-left: 10px;
    }
  }
}

.confirm {
  .content {
    padding: 20px 12px 0;
    font-size: 14px;
    line-height: 20px;

    .green-title {
      margin-bottom: 12px;

      .green-line {
        display: inline-block;
        width: 4px;
        height: 20px;
        border-radius: 3px;
        background: #08A681;
        vertical-align: top;
      }

      .con {
        display: inline-block;
        margin-left: 6px;
        font-weight: bold;
        vertical-align: top;
      }
    }

    .invoice-title {
      margin-bottom: 20px;

      .con {
        margin-bottom: 12px;
      }
    }

    .invoice-detial {
      margin-bottom: 20px;

      /deep/ .el-table__row {
        > td {
          border-bottom: 0;
        }
      }

      /deep/ .el-table::before {
        height: 0;
      }

      .total {
        display: flex;
        justify-content: space-between;
        width: 426px;
        height: 44px;
        border-top: 1px dashed #ebebeb;
        border-left: 1px solid #ebebeb;
        border-right: 1px solid #ebebeb;
        border-bottom: 1px solid #ebebeb;
        line-height: 44px;
        padding: 0 12px;

        .con {
          font-weight: bolder;
        }

        .red {
          color: #ff533a;
        }

        .sign {
          font-size: 14px;
        }

        .word {
          font-size: 22px;
          font-weight: 600;
        }

        .gray {
          color: #999;
        }
      }
    }
  }

  .footer {
    margin-top: 20px;
    height: 49px;
    border-top: 1px solid #ebebeb;

    .use-btn {
      margin: 7px auto;

      .my-button-cancel {
        margin-left: 10px;
      }
    }
  }

  .confirmed {
    height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon {
      margin-top: 70px;
      width: 110px;
      height: 110px;
    }

    .tip1 {
      margin-top: 14px;
      font-size: 16px;
      line-height: 22px;
      color: #333;
    }

    .tip2 {
      margin-top: 8px;
      font-size: 14px;
      line-height: 20px;
      color: #999;
    }
  }
}
</style>
